export default {
    settingsDriverStatus_name: "Nombre",
    "settingsDriverStatus_clockIn": "Marcar entrada",
    "settingsDriverStatus_clockOut": "Marcar salida",
    "settingsDriverStatus_meakbegin": "Inicio descanso",
    "settingsDriverStatus_meakEnd": "Fin descanso",
};